<template>
  <div class="register">
    <el-steps
      align-center
      :active="active"
      finish-status="success"
    >
      <el-step title="注册用户"></el-step>
      <el-step title="填写会员资料"></el-step>
      <el-step title="等待审批"></el-step>
      <el-step title="在线缴费"></el-step>
      <el-step title="正式入会"></el-step>
    </el-steps>

    <template v-if="active === 0">
      <el-row :gutter="gutterValue">
        <el-col :lg="16" :xs="24"
          ><el-card class="register-card">
            <el-form
              ref="userForm"
              :model="userForm"
              :rules="userFormRules"
            >
              <el-form-item label="会员类别" prop="user_type">
                <el-select
                  v-model="userForm.user_type"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsDict.membershipCategory"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号" prop="login_phone">
                <el-input v-model="userForm.login_phone"> </el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="sms_code">
                <el-input v-model="userForm.sms_code">
                  <template slot="append"
                    ><el-button
                      type="text"
                      :disabled="isDisabled"
                      @click="sendSmsCode()"
                      style="width: 100px"
                    >
                      {{ buttonText }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="密码" prop="login_password">
                <el-input
                  type="password"
                  v-model="userForm.login_password"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="check_password">
                <el-input
                  type="password"
                  v-model="userForm.check_password"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
            <el-checkbox v-model="isAgree">我已阅读并同意</el-checkbox><span class="xuzhispan" @click="getPageFun(3)">《须知》</span>
            <div class="register-btn-center">
              <el-button type="warning" @click="userLogin()"
                >确认并注册</el-button
              >
            </div>
          </el-card>
        </el-col>
        <el-col :lg="8" :xs="24"
        :style="{ textAlign: gutterValue === 0 ? 'center' : 'left' }"
          ><el-card class="register-card">
            <div class="register-tips-header">入会必读</div>
            <div class="register-tips-content" @click="getPageFun(2)">
              协会简介
            </div>
            <div class="register-tips-content" @click="getPageFun(3)">
              协会章程
            </div>
            <div class="register-tips-content" @click="getPageFun(4)">
              入会流程
            </div>
            <div class="register-tips-content" @click="getPageFun(5)">
              个人缴费说明
            </div>
            <div class="register-tips-content" @click="getPageFun(6)">
              单位缴费说明
            </div>
            <div class="register-tips-content" @click="getPageFun(7)">
              如何找回登录密码?
            </div>
            <div class="register-tips-header">会员服务</div>
            <div class="register-tips-content">电话：010-89940219</div>
            <div class="register-tips-content">微信：guanyupeng</div>
            <img src="@/assets/images/wechatqrcode.png" alt="" /> </el-card
        ></el-col>
      </el-row>
    </template>
    <el-card v-else-if="active === 1" class="register-card">
      <template v-if="userForm.user_type == '个人会员'">
        <div class="register-tips">
          您正在申请成为中国民族民间工艺美术家协会会员，请填写会员资料
        </div>
        <UserInfo></UserInfo>
      </template>
      <template v-else>
        <div class="register-tips">
          您正在申请成为中国民族民间工艺美术家协会会员，请填写会员资料
        </div>
        <OrgUserInfo></OrgUserInfo>
      </template>
    </el-card>
    <el-card v-else-if="active === 2" class="register-card">
      <div class="register-tips register-line2">
        您的申请资料已提交，请等待审批。
      </div>
      <div class="register-btn-center">
        <el-button type="primary" @click="active = 1"
          >我要修改申请资料</el-button
        >
      </div>
      <div class="register-tips register-line2" style="color: #aaaaaa">
        如有疑问，请致电咨询<br />010-89940219
      </div>
    </el-card>
    <el-card v-else-if="active === 3" class="register-card">

      <div class="ql-editor" v-html="payTipsContent"></div>
      <el-row>
        <el-form  :model="form01" :rules="rules0" ref="formRef">
          <el-col :span="24">
            <el-form-item label="缴费金额" prop="payMoney" >
              <el-input
                v-model.number="form01.payMoney"
                placeholder="请输入缴费金额"
              ></el-input>
            </el-form-item>
          </el-col >
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
              v-model="form01.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col >
        
      <div class="register-tips register-line2">
        根据您所选择的汇款方式，将汇款成功的凭证截图
      </div>
      <div class="register-btn-center">
        <el-upload
          class="upload-demo"
          :action="actionURL"
          :limit="1"
          accept="image/*"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-change = "handleRemove"
          list-type="picture"
          :auto-upload = "false"
          :http-request = "uploadFile"
        >
          <el-button type="primary">上传缴费成功凭证</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>
      </div>
      <el-form-item>
      <el-button 
        class="register-btn-center"
        type="success" 
        @click="submitForm"
      >提交</el-button>
      <div>
      <el-button 
        class="register-btn-center"
        type="text" 
        @click="otherPayClick"
      >为他人缴费</el-button>
    </div>
    </el-form-item>
      <div class="register-tips register-line2" style="color: #aaaaaa">
        如有疑问，请致电咨询<br />010-89940219
      </div>
    </el-form>
      </el-row>
      
    </el-card>
    <el-card v-else-if="active === 4" class="register-card">
      <el-tabs :tab-position="tabPosition" value="3" style="min-height: 400px">
        <el-tab-pane label="会员中心" name="1">
          <UserInfo readonly v-if="userForm.user_type == '个人会员'"></UserInfo>
          <OrgUserInfo v-else readonly></OrgUserInfo>
        </el-tab-pane>
        <!-- <el-tab-pane label="修改手机号">修改手机号</el-tab-pane> -->
        <el-tab-pane label="完善资料" name="2">
          <UserInfo v-if="userForm.user_type == '个人会员'"></UserInfo>
          <OrgUserInfo v-else></OrgUserInfo>
        </el-tab-pane>
        <el-tab-pane label="缴费情况" name="3">
          <el-table
            :data="jfTableData"
            style="width: 100%">
            <el-table-column
              prop="jfnd"
              label="缴费年份"
              width="180">
            </el-table-column>
            <el-table-column
              prop="jfje"
              label="缴费金额"
              width="180">
            </el-table-column>
            <el-table-column
              prop="jfsj"
              label="缴费时间">
            </el-table-column>
            <el-table-column
              prop="payment_status"
              label="缴费状态">
            </el-table-column>
          </el-table>
          <!-- <div class="jfqk-span">
            {{ (status == 3 || status == 5) ? "未缴费" : (status == 1 ?  "已经提交缴费信息，等待审核" : "已缴费") }}
          </div> v-if="status == 3 || status == 5"-->
          <el-button 
            class="register-btn-center"
            @click="selfPayClick"
          >去缴费</el-button>

        </el-tab-pane>
        <!-- <el-tab-pane label="修改密码">修改密码</el-tab-pane> -->
      </el-tabs>
    </el-card>
    <el-dialog :visible.sync="pageVisible" :title="pageTitle" :width="dialogWidth">
      <div
        v-html="pageContent"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/api/service";
import cookies from "@/libs/util.cookies";
import UserInfo from "./components/userInfo.vue";
import OrgUserInfo from "./components/orgUserInfo.vue";

export default {
  components: { UserInfo, OrgUserInfo },
  data() {
    return {
      active: 0,
      gutterValue: 40,
      dialogWidth: '30%',
      tabPosition: 'left',
      leftTabsValue: '3',
      status: 0,
      jfTableData: [],
      isAgree: true,
      // 倒计时秒数
      countdown: 0,
      // 按钮是否禁用
      isDisabled: false,
      // 按钮显示的文本
      buttonText: "发送验证码",
      optionsDict: {
        membershipCategory: [],
      },
      fileList: [],
      actionURL: "/app/uploadPayFile",
      userForm: {
        user_type: "个人会员",
        login_password: "",
        check_password: "",
        login_phone: "",
        sms_code: "",
      },
      form01:{
        payMoney: null,
        remark: ''
      },
      rules0: {
        payMoney: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { type: 'number', message: '必须为数字值' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      userFormRules: {
        userType: [
          {
            required: true,
            message: "请选择会员类型",
            trigger: "change",
          },
        ],
        login_phone: [
          {
            validator: (rule, value, callback) => {
              const reg = /^1\d{10}$/;
              if (!value) {
                return callback(new Error("手机号不能为空"));
              }
              if (!reg.test(value)) {
                return callback(new Error("请输入以 1 开头的 11 位数字"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        sms_code: [
          {
            validator: (rule, value, callback) => {
              const reg = /^\d{4}$/;
              if (!value) {
                return callback(new Error("验证码不能为空"));
              }
              if (!reg.test(value)) {
                return callback(new Error("请输入 4 位数字验证码"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        login_password: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("登录密码不能为空"));
              }
              if (value.length < 6 || value.length > 25) {
                return callback(new Error("登录密码长度应为6-25个字符，且应包含数字和英文字母"));
              }

              // 检测是否包含数字
              const hasNumber = /\d/.test(value);
              // 检测是否包含英文字母（大小写）
              const hasLetter = /[a-zA-Z]/.test(value);
              // 同时满足两个条件才返回true
              if (hasNumber && hasLetter) {
                return callback();
              } else {
                return callback(new Error("登录密码必须包含数字和字母"));
              }
            },
            trigger: "blur",
          },
        ],
        check_password: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("确认密码不能为空"));
              }
              if (value !== this.userForm.login_password) {
                return callback(new Error("两次输入的密码不一致"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      form1: {
        name: "",
      },
      options: [
        { value: "男", label: "男" },
        { value: "女", label: "女" },
      ],
      rules: {},
      rules1: {},

      pageVisible: false,
      pageTitle: "",
      pageContent: "",
      payTipsContent: "",
    };
  },
  mounted() {
    this.userForm.user_type = cookies.get("user_type");
    this.updateGutter();
    window.addEventListener("resize", this.updateGutter);

    this.getUserStatusFun();
    this.getDictFun();
    this.getPageFun(1);
    this.getUserOrderList();

    console.log(this.form1.user_type);
    var baseURL = process.env.VUE_APP_API;
    let uuid = cookies.get("uuid");
    this.actionURL =
      baseURL +
      "/app/uploadPayFile?key=" +
      uuid +
      "&user_type=" +
      cookies.get("user_type");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateGutter);
  },
  methods: {
    updateGutter() {
      if (window.innerWidth < 768) {
        this.gutterValue = 0; // 小屏幕时设为 0
        this.tabPosition = "top";
        this.dialogWidth = '90%';
      } else {
        this.gutterValue = 40;
        this.tabPosition = "left";
        this.dialogWidth = '30%';
      }
    },
    otherPayClick () {
      this.$router.push({
        name: "pay",
      });
    },
    getUserOrderList() {
      request({
          url: "/app/getUserOrderList",
          method: 'post'
        }).then(res => {
          console.log(res);
          if (res.code === 2000) {
            this.jfTableData = res.data
          }
        })
    },
    selfPayClick () {
      this.$router.push({
        name: "selfPay",
      });
    },
    // 上传文件
    async submitForm() {
      try {
        // 表单验证
        await this.$refs.formRef.validate()
        
        // 文件验证
        if (this.fileList.length === 0) {
          this.$message.error('请上传缴费凭证')
          return
        }

        const formData = new FormData()
        formData.append('file', this.fileList[0].raw)  // 文件字段
        formData.append('pay_money', this.form01.payMoney)
        formData.append('remark', this.form01.remark)
        formData.append('uuid', cookies.get("uuid"))
        formData.append('user_type', this.userForm.user_type)
    
        request({
          url: "/app/uploadPayFile",
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log(res);
          if (res.code == 2000) {
            this.$alert('上传成功，等待管理员审核', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        })

      } catch (error) {
        if (error.name !== 'ValidationError') {
          console.error('提交失败:', error)
          this.$message.error('提交失败')
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(11);
      this.fileList = fileList
    },
    uploadFile() {
      console.log(1);
    },
    getUserStatusFun() {
      var self = this;
      request({
        url: "/app/getUserStatus",
        method: "post",
        data: {
          user_type: this.userForm.user_type,
        },
      }).then((res) => {        
        self.status = res.data.status;
        cookies.set("status", res.data.status);

        let uuid = cookies.get("uuid");
        let status = Number(cookies.get("status"));
        if (status == 4 || status == 5) {
          self.active = 4;
        } else if (status == 2 || status == 3) {
          self.active = 3;
        } else if (status == 1) {
          self.active = 2;
        } else if (uuid && uuid.length > 0) {
          self.active = 1;
        } else {
          self.active = 0;
        }
      });
    },
    getDictFun() {
      var self = this;
      request({
        url: "/app/getDictionary",
        method: "post",
        data: {
          keys: [
            "membershipCategory", // 会员类型
            "organization", // 分支机构
          ],
        },
      }).then((res) => {
        self.optionsDict = res.data;
        console.log(self.optionsDict.membershipCategory);
      });
    },
    sendSmsCode() {
      this.$refs.userForm.validateField("login_phone", (error) => {
        if (error) {
          return;
        } else {
          var self = this;
          request({
            url: "/app/sendCode",
            method: "post",
            data: {
              phone: this.userForm.login_phone,
            },
          }).then((res) => {
            if (res.code == 2000) {
              self.userForm.key = res.data.key;
              self.$message({
                message: "发送成功",
                type: "success",
              });
              self.setCodeBtnFun();
            } else {
              self.$message.error(res.msg);
            }
          });
        }
      });
    },
    setCodeBtnFun() {
      // 禁用按钮
      this.isDisabled = true;
      this.countdown = 60;
      this.buttonText = `${this.countdown} 秒后重试`;

      const timer = setInterval(() => {
        this.countdown--;
        this.buttonText = `${this.countdown} 秒后重试`;

        if (this.countdown <= 0) {
          // 清除定时器
          clearInterval(timer);
          // 启用按钮
          this.isDisabled = false;
          this.buttonText = "发送验证码";
        }
      }, 1000);
    },
    getPageFun(pageid) {
      var self = this;
      request({
        url: "/app/getPage/" + pageid + "/",
        method: "get",
        data: {},
      }).then((res) => {
        
        if (pageid === 1) {
          self.payTipsContent = res.data.content;
          console.log(self.payTipsContent);
        } else {
          console.log(res);
          self.pageVisible = true;
          self.pageTitle = res.data.title;
          self.pageContent = res.data.content;
        }
      });
    },
    userLogin() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          var self = this;
          request({
            url: "/app/userRegister",
            method: "post",
            data: {
              user_type: this.userForm.user_type,
              login_phone: this.userForm.login_phone,
              sms_code: this.userForm.sms_code,
              key: this.userForm.key,
              login_password: this.userForm.login_password,
            },
          }).then((res) => {
            console.log(res);
            if (res.code == 2000) {
              cookies.set("uuid", res.data.uuid);
              cookies.set("user_type", res.data.user_type);
              self.active = 1;
              window.location.reload();
            } else {
              self.$message.error(res.msg);
            }
          });
        }
      });
    },
    handlePreview(file) {
      console.log(file);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .register {
    margin: 0 auto;
    padding: 20px 0 0 0;
  }
}
@media (min-width: 768px) { 
  .register {
    width: 964px;
    margin: 0 auto;
    padding: 20px 0 0 0;
  }
}

.register-tips {
  font-size: 16px;
  color: #b8741a;
  margin: 40px 0;
  text-align: center;
}
.register-card {
  margin: 40px 0;
  .jfqk-span {
    text-align: center;
    font-weight: 700;
    font-size: 20px;
  }
}
.register-line2 {
  line-height: 40px;
}
.register-btn-center {
  margin: 40px auto;
  display: grid;
  place-items: center;
}

.register-tips-header {
  margin: 10px 0 0 10px;
  font-size: 14px;
  color: #333333;
  line-height: 30px;
}
.register-tips-content {
  margin-left: 10px;
  font-size: 14px;
  color: #0000EE;
  line-height: 30px;
  cursor: pointer;
}
</style>

<style>
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
 .ql-container {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    height: 100%;
    margin: 0px;
    position: relative;
  }
  .ql-container.ql-disabled .ql-tooltip {
    visibility: hidden;
  }
  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
    pointer-events: none;
  }
  .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }
  .ql-clipboard p {
    margin: 0;
    padding: 0;
  }
  .ql-editor {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    -o-tab-size: 4;
       tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .ql-editor > * {
    cursor: text;
  }
  .ql-editor p,
  .ql-editor ol,
  .ql-editor ul,
  .ql-editor pre,
  .ql-editor blockquote,
  .ql-editor h1,
  .ql-editor h2,
  .ql-editor h3,
  .ql-editor h4,
  .ql-editor h5,
  .ql-editor h6 {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em;
  }
  .ql-editor ol > li,
  .ql-editor ul > li {
    list-style-type: none;
  }
  .ql-editor ul > li::before {
    content: '\2022';
  }
  .ql-editor ul[data-checked=true],
  .ql-editor ul[data-checked=false] {
    pointer-events: none;
  }
  .ql-editor ul[data-checked=true] > li *,
  .ql-editor ul[data-checked=false] > li * {
    pointer-events: all;
  }
  .ql-editor ul[data-checked=true] > li::before,
  .ql-editor ul[data-checked=false] > li::before {
    color: #777;
    cursor: pointer;
    pointer-events: all;
  }
  .ql-editor ul[data-checked=true] > li::before {
    content: '\2611';
  }
  .ql-editor ul[data-checked=false] > li::before {
    content: '\2610';
  }
  .ql-editor li::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  .ql-editor li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }
  .ql-editor li.ql-direction-rtl::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
  }
  .ql-editor ol li:not(.ql-direction-rtl),
  .ql-editor ul li:not(.ql-direction-rtl) {
    padding-left: 1.5em;
  }
  .ql-editor ol li.ql-direction-rtl,
  .ql-editor ul li.ql-direction-rtl {
    padding-right: 1.5em;
  }
  .ql-editor ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-0;
  }
  .ql-editor ol li:before {
    content: counter(list-0, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-increment: list-1;
  }
  .ql-editor ol li.ql-indent-1:before {
    content: counter(list-1, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-2 {
    counter-increment: list-2;
  }
  .ql-editor ol li.ql-indent-2:before {
    content: counter(list-2, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-3 {
    counter-increment: list-3;
  }
  .ql-editor ol li.ql-indent-3:before {
    content: counter(list-3, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-4 {
    counter-increment: list-4;
  }
  .ql-editor ol li.ql-indent-4:before {
    content: counter(list-4, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-5 {
    counter-increment: list-5;
  }
  .ql-editor ol li.ql-indent-5:before {
    content: counter(list-5, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-6 {
    counter-increment: list-6;
  }
  .ql-editor ol li.ql-indent-6:before {
    content: counter(list-6, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-7 {
    counter-increment: list-7;
  }
  .ql-editor ol li.ql-indent-7:before {
    content: counter(list-7, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-7 {
    counter-reset: list-8 list-9;
  }
  .ql-editor ol li.ql-indent-8 {
    counter-increment: list-8;
  }
  .ql-editor ol li.ql-indent-8:before {
    content: counter(list-8, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-8 {
    counter-reset: list-9;
  }
  .ql-editor ol li.ql-indent-9 {
    counter-increment: list-9;
  }
  .ql-editor ol li.ql-indent-9:before {
    content: counter(list-9, decimal) '. ';
  }
  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 4.5em;
  }
  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3em;
  }
  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 4.5em;
  }
  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }
  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 7.5em;
  }
  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 6em;
  }
  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 7.5em;
  }
  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }
  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 10.5em;
  }
  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 9em;
  }
  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 10.5em;
  }
  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em;
  }
  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 13.5em;
  }
  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 12em;
  }
  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 13.5em;
  }
  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em;
  }
  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 16.5em;
  }
  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 15em;
  }
  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 16.5em;
  }
  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em;
  }
  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 19.5em;
  }
  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 18em;
  }
  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 19.5em;
  }
  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em;
  }
  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 22.5em;
  }
  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 21em;
  }
  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 22.5em;
  }
  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em;
  }
  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 25.5em;
  }
  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 24em;
  }
  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 25.5em;
  }
  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 27em;
  }
  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 28.5em;
  }
  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 27em;
  }
  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 28.5em;
  }
  .ql-editor .ql-video {
    display: block;
    max-width: 100%;
  }
  .ql-editor .ql-video.ql-align-center {
    margin: 0 auto;
  }
  .ql-editor .ql-video.ql-align-right {
    margin: 0 0 0 auto;
  }
  .ql-editor .ql-bg-black {
    background-color: #000;
  }
  .ql-editor .ql-bg-red {
    background-color: #e60000;
  }
  .ql-editor .ql-bg-orange {
    background-color: #f90;
  }
  .ql-editor .ql-bg-yellow {
    background-color: #ff0;
  }
  .ql-editor .ql-bg-green {
    background-color: #008a00;
  }
  .ql-editor .ql-bg-blue {
    background-color: #06c;
  }
  .ql-editor .ql-bg-purple {
    background-color: #93f;
  }
  .ql-editor .ql-color-white {
    color: #fff;
  }
  .ql-editor .ql-color-red {
    color: #e60000;
  }
  .ql-editor .ql-color-orange {
    color: #f90;
  }
  .ql-editor .ql-color-yellow {
    color: #ff0;
  }
  .ql-editor .ql-color-green {
    color: #008a00;
  }
  .ql-editor .ql-color-blue {
    color: #06c;
  }
  .ql-editor .ql-color-purple {
    color: #93f;
  }
  .ql-editor .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-editor .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-editor .ql-size-small {
    font-size: 0.75em;
  }
  .ql-editor .ql-size-large {
    font-size: 1.5em;
  }
  .ql-editor .ql-size-huge {
    font-size: 2.5em;
  }
  .ql-editor .ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
  }
  .ql-editor .ql-align-center {
    text-align: center;
  }
  .ql-editor .ql-align-justify {
    text-align: justify;
  }
  .ql-editor .ql-align-right {
    text-align: right;
  }
  .ql-editor.ql-blank::before {
    color: rgba(0,0,0,0.6);
    content: attr(data-placeholder);
    font-style: italic;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
  }
  .ql-snow.ql-toolbar:after,
  .ql-snow .ql-toolbar:after {
    clear: both;
    content: '';
    display: table;
  }
  .ql-snow.ql-toolbar button,
  .ql-snow .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: left;
    height: 24px;
    padding: 3px 5px;
    width: 28px;
  }
  .ql-snow.ql-toolbar button svg,
  .ql-snow .ql-toolbar button svg {
    float: left;
    height: 100%;
  }
  .ql-snow.ql-toolbar button:active:hover,
  .ql-snow .ql-toolbar button:active:hover {
    outline: none;
  }
  .ql-snow.ql-toolbar input.ql-image[type=file],
  .ql-snow .ql-toolbar input.ql-image[type=file] {
    display: none;
  }
  .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover,
  .ql-snow.ql-toolbar button:focus,
  .ql-snow .ql-toolbar button:focus,
  .ql-snow.ql-toolbar button.ql-active,
  .ql-snow .ql-toolbar button.ql-active,
  .ql-snow.ql-toolbar .ql-picker-label:hover,
  .ql-snow .ql-toolbar .ql-picker-label:hover,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active,
  .ql-snow.ql-toolbar .ql-picker-item:hover,
  .ql-snow .ql-toolbar .ql-picker-item:hover,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
    color: #06c;
  }
  .ql-snow.ql-toolbar button:hover .ql-fill,
  .ql-snow .ql-toolbar button:hover .ql-fill,
  .ql-snow.ql-toolbar button:focus .ql-fill,
  .ql-snow .ql-toolbar button:focus .ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
    fill: #06c;
  }
  .ql-snow.ql-toolbar button:hover .ql-stroke,
  .ql-snow .ql-toolbar button:hover .ql-stroke,
  .ql-snow.ql-toolbar button:focus .ql-stroke,
  .ql-snow .ql-toolbar button:focus .ql-stroke,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow.ql-toolbar button:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar button:focus .ql-stroke-miter,
  .ql-snow .ql-toolbar button:focus .ql-stroke-miter,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
    stroke: #06c;
  }
  @media (pointer: coarse) {
    .ql-snow.ql-toolbar button:hover:not(.ql-active),
    .ql-snow .ql-toolbar button:hover:not(.ql-active) {
      color: #444;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
      fill: #444;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
      stroke: #444;
    }
  }
  .ql-snow {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }
  .ql-snow * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }
  .ql-snow .ql-hidden {
    display: none;
  }
  .ql-snow .ql-out-bottom,
  .ql-snow .ql-out-top {
    visibility: hidden;
  }
  .ql-snow .ql-tooltip {
    position: absolute;
    -webkit-transform: translateY(10px);
            transform: translateY(10px);
  }
  .ql-snow .ql-tooltip a {
    cursor: pointer;
    text-decoration: none;
  }
  .ql-snow .ql-tooltip.ql-flip {
    -webkit-transform: translateY(-10px);
            transform: translateY(-10px);
  }
  .ql-snow .ql-formats {
    display: inline-block;
    vertical-align: middle;
  }
  .ql-snow .ql-formats:after {
    clear: both;
    content: '';
    display: table;
  }
  .ql-snow .ql-stroke {
    fill: none;
    stroke: #444;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }
  .ql-snow .ql-stroke-miter {
    fill: none;
    stroke: #444;
    stroke-miterlimit: 10;
    stroke-width: 2;
  }
  .ql-snow .ql-fill,
  .ql-snow .ql-stroke.ql-fill {
    fill: #444;
  }
  .ql-snow .ql-empty {
    fill: none;
  }
  .ql-snow .ql-even {
    fill-rule: evenodd;
  }
  .ql-snow .ql-thin,
  .ql-snow .ql-stroke.ql-thin {
    stroke-width: 1;
  }
  .ql-snow .ql-transparent {
    opacity: 0.4;
  }
  .ql-snow .ql-direction svg:last-child {
    display: none;
  }
  .ql-snow .ql-direction.ql-active svg:last-child {
    display: inline;
  }
  .ql-snow .ql-direction.ql-active svg:first-child {
    display: none;
  }
  .ql-snow .ql-editor h1 {
    font-size: 2em;
  }
  .ql-snow .ql-editor h2 {
    font-size: 1.5em;
  }
  .ql-snow .ql-editor h3 {
    font-size: 1.17em;
  }
  .ql-snow .ql-editor h4 {
    font-size: 1em;
  }
  .ql-snow .ql-editor h5 {
    font-size: 0.83em;
  }
  .ql-snow .ql-editor h6 {
    font-size: 0.67em;
  }
  .ql-snow .ql-editor a {
    text-decoration: underline;
  }
  .ql-snow .ql-editor blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }
  .ql-snow .ql-editor code,
  .ql-snow .ql-editor pre {
    background-color: #f0f0f0;
    border-radius: 3px;
  }
  .ql-snow .ql-editor pre {
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
  }
  .ql-snow .ql-editor code {
    font-size: 85%;
    padding: 2px 4px;
  }
  .ql-snow .ql-editor pre.ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
  }
  .ql-snow .ql-editor img {
    max-width: 100%;
  }
  .ql-snow .ql-picker {
    color: #444;
    display: inline-block;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    position: relative;
    vertical-align: middle;
  }
  .ql-snow .ql-picker-label {
    cursor: pointer;
    display: inline-block;
    height: 100%;
    padding-left: 8px;
    padding-right: 2px;
    position: relative;
    width: 100%;
  }
  .ql-snow .ql-picker-label::before {
    display: inline-block;
    line-height: 22px;
  }
  .ql-snow .ql-picker-options {
    background-color: #fff;
    display: none;
    min-width: 100%;
    padding: 4px 8px;
    position: absolute;
    white-space: nowrap;
  }
  .ql-snow .ql-picker-options .ql-picker-item {
    cursor: pointer;
    display: block;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #ccc;
    z-index: 2;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #ccc;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #ccc;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    margin-top: -1px;
    top: 100%;
    z-index: 1;
  }
  .ql-snow .ql-color-picker,
  .ql-snow .ql-icon-picker {
    width: 28px;
  }
  .ql-snow .ql-color-picker .ql-picker-label,
  .ql-snow .ql-icon-picker .ql-picker-label {
    padding: 2px 4px;
  }
  .ql-snow .ql-color-picker .ql-picker-label svg,
  .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
  }
  .ql-snow .ql-icon-picker .ql-picker-options {
    padding: 4px 0px;
  }
  .ql-snow .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px;
    padding: 2px 4px;
  }
  .ql-snow .ql-color-picker .ql-picker-options {
    padding: 3px 5px;
    width: 152px;
  }
  .ql-snow .ql-color-picker .ql-picker-item {
    border: 1px solid transparent;
    float: left;
    height: 16px;
    margin: 2px;
    padding: 0px;
    width: 16px;
  }
  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    position: absolute;
    margin-top: -9px;
    right: 0;
    top: 50%;
    width: 18px;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }
  .ql-snow .ql-picker.ql-header {
    width: 98px;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: 'Normal';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: 'Heading 1';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: 'Heading 2';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: 'Heading 3';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: 'Heading 4';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: 'Heading 5';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: 'Heading 6';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    font-size: 2em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    font-size: 1.5em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    font-size: 1.17em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    font-size: 1em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    font-size: 0.83em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    font-size: 0.67em;
  }
  .ql-snow .ql-picker.ql-font {
    width: 108px;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: 'Sans Serif';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: 'Serif';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: 'Monospace';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-snow .ql-picker.ql-size {
    width: 98px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: 'Normal';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: 'Small';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: 'Large';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: 'Huge';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    font-size: 10px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    font-size: 18px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    font-size: 32px;
  }
  .ql-snow .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff;
  }
  .ql-snow .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000;
  }
  .ql-toolbar.ql-snow {
    border: 1px solid #ccc;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
  }
  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
  }
  .ql-toolbar.ql-snow .ql-picker-label {
    border: 1px solid transparent;
  }
  .ql-toolbar.ql-snow .ql-picker-options {
    border: 1px solid transparent;
    -webkit-box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
            box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
  }
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    border-color: #ccc;
  }
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc;
  }
  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0px;
  }
  .ql-snow .ql-tooltip {
    background-color: #fff;
    border: 1px solid #ccc;
    -webkit-box-shadow: 0px 0px 5px #ddd;
            box-shadow: 0px 0px 5px #ddd;
    color: #444;
    padding: 5px 12px;
    white-space: nowrap;
  }
  .ql-snow .ql-tooltip::before {
    content: "Visit URL:";
    line-height: 26px;
    margin-right: 8px;
  }
  .ql-snow .ql-tooltip input[type=text] {
    display: none;
    border: 1px solid #ccc;
    font-size: 13px;
    height: 26px;
    margin: 0px;
    padding: 3px 5px;
    width: 170px;
  }
  .ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }
  .ql-snow .ql-tooltip a.ql-action::after {
    border-right: 1px solid #ccc;
    content: 'Edit';
    margin-left: 16px;
    padding-right: 8px;
  }
  .ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remove';
    margin-left: 8px;
  }
  .ql-snow .ql-tooltip a {
    line-height: 26px;
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-preview,
  .ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none;
  }
  .ql-snow .ql-tooltip.ql-editing input[type=text] {
    display: inline-block;
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: 'Save';
    padding-right: 0px;
  }
  .ql-snow .ql-tooltip[data-mode=link]::before {
    content: "Enter link:";
  }
  .ql-snow .ql-tooltip[data-mode=formula]::before {
    content: "Enter formula:";
  }
  .ql-snow .ql-tooltip[data-mode=video]::before {
    content: "Enter video:";
  }
  .ql-snow a {
    color: #06c;
  }
  .ql-container.ql-snow {
    border: 1px solid #ccc;
  }

  .xuzhispan {
    color: #409EFF;
    cursor: pointer;
  }
</style>